import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col w-full bg-brand-black my-auto h-full px-6 z-50" }
const _hoisted_2 = { class: "flex flex-col m-auto space-y-14 items-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col space-y-4 items-center" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "111",
    height: "110",
    viewBox: "0 0 111 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("rect", {
      x: "2.5",
      y: "2",
      width: "106",
      height: "106",
      rx: "53",
      fill: "#EBFF00"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M56 72C57.925 72 59.5 70.4308 59.5 68.5128H52.5C52.5 70.4308 54.0575 72 56 72ZM66.5 61.5385V52.8205C66.5 47.4677 63.63 42.9867 58.625 41.801V40.6154C58.625 39.1682 57.4525 38 56 38C54.5475 38 53.375 39.1682 53.375 40.6154V41.801C48.3525 42.9867 45.5 47.4503 45.5 52.8205V61.5385L42 65.0256V66.7692H70V65.0256L66.5 61.5385Z",
      fill: "#1A1B22"
    }),
    /*#__PURE__*/_createElementVNode("rect", {
      x: "2.5",
      y: "2",
      width: "106",
      height: "106",
      rx: "53",
      stroke: "#EBFF00",
      "stroke-width": "4"
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col w-full items-center space-y-2" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "flex m-auto text-white text-2xl font-medium" }, "Allow notifications"),
    /*#__PURE__*/_createElementVNode("div", { class: "m-auto text-brand-light-gray text-lg text-center" }, "Don’t miss a thing. Get notified when you get a new message. ")
  ])
], -1)
const _hoisted_4 = { class: "flex flex-col space-y-2 w-full" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "flex m-auto space-x-2.5" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "my-auto pt-0.5" }, " I want to be notified ")
], -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "flex m-auto space-x-2.5" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "my-auto pt-0.5" }, " Not now ")
], -1)
const _hoisted_8 = [
  _hoisted_7
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("button", {
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.registerForPush && _ctx.registerForPush(...args))),
                  class: "flex bg-brand-lime rounded-full w-full h-14 font-medium text-xl text-brand-black"
                }, _hoisted_6),
                _createElementVNode("button", {
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.forward && _ctx.forward(...args))),
                  class: "flex bg-brand-dark-gray rounded-full w-full h-14 font-medium text-xl text-white"
                }, _hoisted_8)
              ])
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}